'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeDOMDriver = makeDOMDriver;

var _snabbdom = require('snabbdom');

var _hold = require('@most/hold');

var _hold2 = _interopRequireDefault(_hold);

var _DOMSource = require('./DOMSource');

var _VNodeWrapper = require('./VNodeWrapper');

var _module = require('./isolate/module');

var _modules = require('./modules');

var _modules2 = _interopRequireDefault(_modules);

var _transposition = require('./transposition');

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeDOMDriverInputGuard(modules) {
  if (!Array.isArray(modules)) {
    throw new Error('Optional modules option must be ' + 'an array for snabbdom modules');
  }
}

function domDriverInputGuard(view$) {
  // eslint-disable-line complexity
  if (!view$ || typeof view$.observe !== 'function' || // eslint-disable-line brace-style
  typeof view$.drain !== 'function') {
    throw new Error('The DOM driver function expects as input a Stream of ' + 'virtual DOM elements');
  }
}

function makeDOMDriver(container) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var transposition = options.transposition || false;
  var modules = options.modules || _modules2.default;
  var isolateModule = new _module.IsolateModule(new Map([]));
  var patch = (0, _snabbdom.init)([isolateModule.createModule()].concat(modules));
  var rootElement = (0, _util.getElement)(container);
  var vNodeWrapper = new _VNodeWrapper.VNodeWrapper(rootElement);
  var delegators = new Map([]);
  makeDOMDriverInputGuard(modules);

  return function DOMDriver(vNode$) {
    domDriverInputGuard(vNode$);
    var preprocessedVNode$ = transposition ? vNode$.map(_transposition.transposeVNode).switch() : vNode$;

    var rootElement$ = preprocessedVNode$.map(function (vNode) {
      return vNodeWrapper.call(vNode);
    }).scan(patch, rootElement).map(function (vNode) {
      return vNode.elm || vNode;
    }).thru(_hold2.default);

    rootElement$.drain();

    return new _DOMSource.DOMSource(rootElement$, [], isolateModule, delegators);
  };
}


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/makeDOMDriver.js
 **/